import { Search } from "lucide-react";

import { useVendors } from "@/api/vendor-query";
import { Input } from "@/components/ui/input";
import { FavoritesBanner } from "@/components/vendor/favourites-banner";
import { RecentlyViewed } from "@/components/vendor/recently-viewed";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/buyer/vendor/")({
	component: RouteComponent
});

function RouteComponent() {
	const { data, isPending } = useVendors();

	return (
		<>
			<div className="relative">
				<Input
					className="w-full bg-gray-50 px-4 py-6 pl-4 pr-12 placeholder:text-muted-foreground placeholder:text-sm"
					placeholder="Find the vendor you're looking for"
					type="search"
				/>
				<Search className="absolute right-4 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-500" />
			</div>
			<FavoritesBanner />
			<RecentlyViewed vendors={data?.data.data ?? []} isLoading={isPending} />
		</>
	);
}
